import dayjs from 'dayjs'

const $str = window.$str;
const lineColor = "#6A727C1A"; // 图表splitLine的颜色
const textColor = "#8b93aa"; // 图表文字的颜色

const defaultMin = dayjs().format('YYYY-MM-DD 00:00:00');
const defaultMax = dayjs().format('YYYY-MM-DD 23:59:59');


export function getChartOption(chartData = [], start = defaultMin, end = defaultMax) {
  const { yMin0, yMax0, yMin1, yMax1 } = getYaxisRange(chartData);

  // 最高电压
  const maxVoltage = []
  // 最低电压
  const minVoltage = []
  // 电芯电压标准差
  const cellVoltageVariance = []
  // 最大压差
  const diff = []
  // 日期
  const time = []


  if (Array.isArray(chartData)) {
    chartData.forEach(elem => {
      const t = dayjs(elem.record_time).format("YYYY-MM-DD HH:mm:ss")
      const max = Number(elem.v_cell_max).toFixed(2)
      const min = Number(elem.v_cell_min).toFixed(2)
      const std = Number(elem.v_cell_std).toFixed(2)
      const dist = (elem.v_cell_max - elem.v_cell_min).toFixed(2)

      maxVoltage.push([t, max])
      minVoltage.push([t, min])
      cellVoltageVariance.push([t, std])
      diff.push([t, dist])
      time.push(t)
    })
  }

  const option = {
    color: ['#1D77F5', '#FFC859', '#2AA523', '#FFA441', '#944DFF', '#EE3CD3', '#FF532D', '#0DE24A'],
    grid: [
      {
        top: '12%',
        left: '1%',
        right: '1%',
        height: '30%',
        containLabel: true
      },
      {
        top: '44%',
        left: '1%',
        right: '1%',
        bottom: '18%',
        containLabel: true
      }
    ],
    xAxis: [
      {
        gridIndex: 0,
        name: $str.getKey('数据分析/时间'),
        type: 'time',
        nameLocation: 'end',
        min: start,
        max: end,
        boundaryGap: false,
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          show: false
        },
        position: 'bottom',
        nameTextStyle: {
          color: '#999',
        },
        axisPointer: {
          label: {
            show: false
          }
        }
      },
      {
        gridIndex: 1,
        name: $str.getKey('数据分析/时间'),
        type: 'time',
        nameLocation: 'end',
        min: start,
        max: end,
        boundaryGap: false,
        axisLine: {
          show: true,
          lineStyle: {
            color: lineColor,
            type: 'dashed'
          }
        },
        axisTick: {
          show: true
        },
        position: 'top',
        nameTextStyle: {
          color: textColor
        },
        axisLabel: {
          color: textColor,
          show: true,
          formatter(value) {
            return dayjs(value).format("YYYY-MM-DD HH:mm:ss").replace(/\s/, '\n');
          },
        },
        axisPointer: {
          label: {
            show: true, // 只在最后一个x轴显示时间标签
            backgroundColor: '#777'
          }
        }
      },
    ],
    yAxis: [
      {
        gridIndex: 0,
        name: $str.getKey('数据分析/电压(mV)'),
        min: yMin0 ?? 2400,
        max: yMax0 ?? 3600,
        nameLocation: 'end',
        nameGap: 15,
        nameTextStyle: {
          align: 'center',
          color: textColor,
          padding: [0, 0, 0, 35]
        },
        type: 'value',
        splitLine: {
          lineStyle: {
            color: '#eee',
            type: 'dashed'
          }
        },
        axisLabel: {
          formatter: function (value) {
            return Math.round(value).toString();
          },
          color: textColor,
        },
        axisLine: {
          show: false
        }
      },
      {
        gridIndex: 1,
        name: $str.getKey('数据分析/压差(mV)'),
        min: yMin1 ?? null,
        max: yMax1 ?? null,
        nameLocation: 'start',
        nameTextStyle: {
          align: 'center',
          color: '#999'
        },
        type: 'value',
        splitLine: {
          show: true,
          lineStyle: {
            color: '#eee',
            type: 'dashed'
          }
        },
        axisLabel: {
          formatter: function (value) {
            return Math.round(value).toString();
          },
          color: '#999',
        },
        axisLine: {
          show: false
        },
        splitNumber: 10
      }
    ],
    series: [
      {
        xAxisIndex: 0,
        yAxisIndex: 0,
        type: 'line',
        name: $str.getKey('数据分析/最高电压'),
        data: maxVoltage,
        showSymbol: false,
        smooth: true,
      },
      {
        xAxisIndex: 0,
        yAxisIndex: 0,
        type: 'line',
        name: $str.getKey('数据分析/最低电压'),
        data: minVoltage,
        showSymbol: false,
        smooth: true,
      },
      {
        xAxisIndex: 0,
        yAxisIndex: 0,
        type: 'line',
        name: $str.getKey('数据分析/电压范围'),
        showSymbol: false,
        markLine: {
          data: [
            {
              name: 'max',
              yAxis: 3600,
              label: {
                formatter: '{b}: {c}'
              }
            },
            {
              name: 'min',
              yAxis: 2400,
              label: {
                formatter: '{b}: {c}'
              }
            },
          ],
          label: {
            show: true,
            position: 'insideEndTop',
            color: 'inherit',
          },
          lineStyle: {
            color: '#2DFFAA'
          }
        },
      },
      {
        xAxisIndex: 1,
        yAxisIndex: 1,
        type: 'line',
        name: $str.getKey('数据分析/电芯电压标准差'),
        data: cellVoltageVariance,
        showSymbol: false,
        smooth: true,
        areaStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
              offset: 0, color: 'rgba(242, 178, 48, 0.6)' // 0% 处的颜色
            }, {
              offset: 1, color: 'rgba(199, 146, 41, 0)' // 100% 处的颜色
            }],
            global: false // 缺省为 false
          }
        }
      },
      {
        xAxisIndex: 1,
        yAxisIndex: 1,
        type: 'line',
        name: $str.getKey('数据分析/最大压差'),
        data: diff,
        showSymbol: false,
        smooth: true,
        areaStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
              offset: 0, color: 'rgba(238, 102, 102, 0.6)' // 0% 处的颜色
            }, {
              offset: 1, color: 'rgba(255, 255, 255, 0.2)' // 100% 处的颜色
            }],
            global: false // 缺省为 false
          }
        }
      },
    ],
    legend: {
      data: [
        $str.getKey('数据分析/最高电压'),
        $str.getKey('数据分析/最低电压'),
        $str.getKey('数据分析/电压范围'),
        $str.getKey('数据分析/电芯电压标准差'),
        $str.getKey('数据分析/最大压差')
      ],
      bottom: 30,
      icon: 'circle',
      itemGap: 20,
      textStyle: {
        color: '#999'
      },
      selected: {
        [$str.getKey('数据分析/最高电压')]: true,
        [$str.getKey('数据分析/最低电压')]: true,
        [$str.getKey('数据分析/电压范围')]: true,
        [$str.getKey('数据分析/电芯电压标准差')]: true,
        [$str.getKey('数据分析/最大压差')]: true,
      }
    },
    tooltip: createTooltip(),
    axisPointer: {
      link: [
        {
          xAxisIndex: [0, 1, 2]
        }
      ],
      label: {
        backgroundColor: '#777'
      }
    },
    dataZoom: [
      {
        height: 12,
        bottom: 8,
        textStyle: {
          color: '#8392A5'
        },
        handleIcon: 'path://M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
        handleSize: '60%',
        dataBackground: {
          areaStyle: {
            color: '#8392A5'
          },
          lineStyle: {
            opacity: 0.8,
            color: '#8392A5'
          }
        },
        brushSelect: true,
        xAxisIndex: [0, 1, 2]
      },
      {
        type: 'inside',
        xAxisIndex: [0, 1, 2]
      }
    ],
    animation: false,
  }

  return option
}

function getYaxisRange(chartData) {
  const result = {
    yMin0: 2400,
    yMax0: 3600,
    yMin1: 0,
    yMax1: 100,
  }
  if (Array.isArray(chartData) && chartData.length > 0) {
    // 自适应计算坐标系1的Y刻度范围 
    chartData.forEach(point => {
      let newValue = Number(point.v_cell_max);
      if (!isNaN(newValue)) {
        result.yMin0 = Math.min(result.yMin0, newValue);
        result.yMax0 = Math.max(result.yMax0, newValue);
      }
      newValue = Number(point.v_cell_min);
      if (!isNaN(newValue)) {
        result.yMin0 = Math.min(result.yMin0, newValue);
        result.yMax0 = Math.max(result.yMax0, newValue);
      }
    })
    const moreRange = (result.yMax0 - result.yMin0) * 0.1;
    result.yMax0 += moreRange;
    result.yMin0 -= moreRange;


    // 自适应计算坐标系2的Y刻度范围 
    const hasUsefullData1 = chartData.some(item => {
      if ((!isNaN(Number(item.v_cell_max)) && !isNaN(Number(item.v_cell_min))) || !isNaN(Number(item.v_cell_std))) {
        return true;
      } else {
        return false;
      }
    })
    if (hasUsefullData1) {
      result.yMin1 = undefined;
      result.yMax1 = undefined;
    }
  }

  return result;
}


function createTooltip(config = {}) {
  const timeFormatter = (value) => {
    // 格式化时间：如果是时间戳，转换为年月日时分秒；如果是时间字符串，直接使用
    let timeValue = value;
    if (typeof timeValue === 'number' || (typeof timeValue === 'string' && /^\d+$/.test(timeValue))) {
      // 判断是否是时间戳（毫秒或秒）
      const timestamp = Number(timeValue);
      const isMillisecond = timestamp > 946684800000; // 2000-01-01的时间戳（毫秒）
      timeValue = dayjs(isMillisecond ? timestamp : timestamp * 1000).format('YYYY-MM-DD HH:mm:ss');
    } else if (timeValue instanceof Date) {
      timeValue = dayjs(timeValue).format('YYYY-MM-DD HH:mm:ss');
    }
    return timeValue;
  };

  return {
    trigger: 'axis',
    axisPointer: {
      type: 'cross'
    },
    className: 'chart-tooltip',
    backgroundColor: 'rgba(255, 255, 255, 0.90)',
    borderWidth: 0,
    textStyle: {
      color: '#6A727C'
    },
    formatter(params) {
      let time = params[0].axisValue;
      time = timeFormatter(time);

      const str = (list) => {
        let t = '';
        for (const item of list) {
          const originPrice = Array.isArray(item.data) ? item.data[1] : item.data;
          const price = formatPriceValueForShow(originPrice);
          t += /* html */`
            <div class="chart-tooltip__series" style="display: flex; align-items: center; justify-content: space-between; gap: 8px; line-height: 1.5;">
              <div style="display: flex; align-items: center; gap: 6px; flex: 1;">
                <div class="chart-tooltip__point" style="background: ${item.color}; width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; display: inline-block; vertical-align: middle;"></div>
                <div class="chart-tooltip__series-name" style="display: inline-block; vertical-align: middle;">${item.seriesName}</div>
              </div>
              <div class="chart-tooltip__value" style="flex-shrink: 0; display: inline-block; vertical-align: middle; text-align: right;">${price ?? '--'}</div>
            </div>`;
        }
        return t;
      };

      return /* html */`
        <div class="chart-tooltip__time" style="margin-bottom: 12px;">${time}</div>
        <div class="chart-tooltip__items-container">${str(params)}</div>
      `;
    }
  }
}

/** 格式化：价格展示时-只保留两位小数 */
function formatPriceValueForShow(price) {
  if (typeof (price) === 'number' || isNaN(price)) {
    return (+price).toFixed(2);
  } else {
    return price
  }
}



